import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import AmazonRedshiftWriterForm from '../forms/amazon-redshift-writer-form';
import { amazonRedshiftWriterValidationSchema } from '../schema/amazonRedshiftWriter.js';

export default function AmazonRedshiftWriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Amazon Redshift Writer Node Details',
        altText: 'Amazon Redshift Writer Node',
        defaultLabel: 'Redshift Writer Node',
      }}
    >
      <CommonNode
        FormComponent={AmazonRedshiftWriterForm}
        schemaResolver={amazonRedshiftWriterValidationSchema}
      />
    </NodeProvider>
  );
}
